import { render, staticRenderFns } from "./AlbumIndex.vue?vue&type=template&id=d1e60bb4&scoped=true"
import script from "./AlbumIndex.vue?vue&type=script&lang=js"
export * from "./AlbumIndex.vue?vue&type=script&lang=js"
import style0 from "./AlbumIndex.vue?vue&type=style&index=0&id=d1e60bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e60bb4",
  null
  
)

export default component.exports